export const CONSONANT_VOWEL_PAIRS_K = [

    // ㅋ
    {
        id: 1,
        korean: "카",
        english: "ka",

    },
    {
        id: 2,
        korean: "케",
        english: "ke",

    },
    {
        id: 3,
        korean: "키",
        english: "ki",

    },
    {
        id: 4,
        korean: "코",
        english: "ko",

    },
    {
        id: 5,
        korean: "크",
        english: "keu",

    },
    {
        id: 6,
        korean: "커",
        english: "keo",

    },
    {
        id: 7,
        korean: "캬",
        english: "kya",

    },
    {
        id: 8,
        korean: "캐",
        english: "kae",

    },
    {
        id: 9,
        korean: "켸",
        english: "kye",

    },
    {
        id: 10,
        korean: "쿄",
        english: "kyo",

    },
    {
        id: 11,
        korean: "켜",
        english: "kyeo",

    },
    {
        id: 12,
        korean: "큐",
        english: "kyu",

    },

    {
        id: 13,
        korean: "칸",
        english: "kan", 

    },
    {
        id: 14,
        korean: "킼",
        english: "kik",

        

    },
    {
        id: 15,
        korean: "킴",
        english: "kim",
        

    },
    {
        id: 16,
        korean: "캋",
        english: "kat",
        

    },
    {
        id: 17,
        korean: "캏",
        english: "kah",
        

    },
    {
        id: 18,
        korean: "컵",
        english: "keob",
        

    },
          {
        id: 19,
        korean: "클",
        english: "keul",
        

    },
    {
        id: 20,
        korean: "캍",
        english: "kat",
        

    },
    {
        id: 21,
        korean: "캒",
        english: "kaekk",
        

    },
    {
        id: 22,
        korean: "캔",
        english: "kaen",
        

    },
    {
        id: 23,
        korean: "킈",
        english: "kui",
        

    },
    {
        id: 24,
        korean: "쿰",
        english: "kum",
        

    },

    {
        id: 25,
        korean: "캿",
        english: "kyat",
        

    },
    {
        id: 26,
        korean: "캍",
        english: "kat",
        

    },
    {
        id: 27,
        korean: "캉",
        english: "kang",
        
    },
    {
        id: 28,
        korean: "칼",
        english: "kal",
        
    },
    {
        id: 29,
        korean: "켤",
        english: "kyeol",
        
    },
    {
        id: 30,
        korean: "엌",
        english: "eok",
        
    },
    {
        id: 31,
        korean: "컿",
        english: "keoh",
        
    },
    {
        id: 32,
        korean: "클",
        english: "keul",
        
    },
    {
        id: 33,
        korean: "쿼",
        english: "kwo",
        
    },
        {
        id: 34,
        korean: "큪",
        english: "kyup",
        
    },
        {
        id: 35,
        korean: "칼",
        english: "kal",
        
    }

    
];

